/*
* 菜单栏logo组件
*/

import { Image, Flex, Typography } from 'antd';
import CNF from '../incs/Config';
import LOGO from '../images/logo.png';

const { Text } = Typography;

const XMenuLogo = ({ collapsed, }) => {
    return (
        <Flex
            align='center'
            style={{
                paddingLeft: collapsed ? 24 : 20,
                height: CNF.menuHeight,
                boxSizing: 'border-box',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <Image
                draggable={false}
                width={30}
                preview={false}
                src={LOGO}
                style={{
                    position: 'absolute',
                    transform: 'translateY(-50%)',
                    width: 30,
                    height: 30,
                    userSelect: 'none',
                    willChange: 'transform', // 开启 GPU 加速，提升渲染平滑度
                }}
            />
            <Text
                style={{
                    color: '#ffffff',
                    whiteSpace: 'nowrap',
                    marginLeft: 12,
                    opacity: collapsed ? 0 : 1,
                    visibility: collapsed ? 'hidden' : 'visible',
                    transition: 'none',
                }}
            >
                {`${CNF.projectCode} ${CNF.version}`}
            </Text>
        </Flex >
    );
}
export default XMenuLogo;